<template>
  <UiPageTitle :title="appLogin" :back-link="{ name: 'applications' }" />
</template>

<script>
import UiPageTitle from '@/components/UiPageTitle.vue'

import currentApplicationMixin from './mixins/currentApplicationMixin'

export default {
  components: { UiPageTitle },
  mixins: [currentApplicationMixin],
}
</script>
